import axios from 'axios'
import { getToken, removeToken } from '../../utils/cookies/cookies'
import configManager from '../../config/configManager'

const configData = configManager()
const axiosInterceptorInstance = axios.create({
  baseURL: configData.API_URL,
})

console.log('API URL:', configData.API_URL)

axiosInterceptorInstance.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      if (config.headers) config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosInterceptorInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.status === 401) {
      removeToken()
      window.location = '/'
    }
    if (error.status === 500 || error.status === 404) {
      window.history.back()
    }
    return Promise.reject(error)
  },
)

export default axiosInterceptorInstance
